import React from 'react';
import { formatNumberWithDecimals } from '@/creditflowresearch/ui/components/deals/helpers';
import { BodyCell } from '@creditflowresearch/uilib/Table/DataTable';
import ICellProps, { ITranchRow } from './ICellProps';

import alignStyles from '@creditflowresearch/uilib/styles/helpers/align.module.scss';

const getCell = ({ row: tranche }: ITranchRow) => (
  tranche.creditEnhancement !== null
    ? `${ formatNumberWithDecimals(tranche.creditEnhancement, 2) }%`
    : '-'
);

const CreditEnhancementCell = ({
  rowIndex,
  tranche,
}: ICellProps) => (
  <BodyCell
    name="CreditEnhancementCell"
    className={ alignStyles.alignCenter }
    rowIndex={ rowIndex }
    rowData={ tranche }
    cellCallback={ getCell }
  />
);

export default CreditEnhancementCell;
